import { Messages } from '../../codegen/Localize';
import { AddDataQualityIndicatorRequest, IAddDataQualityIndicatorParams } from '../../ts/ServerApi/requests/AddDataQualityIndicatorRequest';
import { IUpdateDataQualityIndicatorParams, UpdateDataQualityIndicatorRequest } from '../../ts/ServerApi/requests/UpdateDataQualityIndicatorRequest';
import { IDeleteDataQualityIndicatorParams, DeleteDataQualityIndicatorRequest } from '../../ts/ServerApi/requests/DeleteDataQualityIndicatorRequest';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { WebHttpClientWithErrorToastInstance } from '../../httpClient/WebHttpClientWithErrorToast';
import { ToasterService, ToastType } from '../../ts/services/ToasterService';

export namespace DataQualityWarningActions {

  function showToastForResult(result: IResult, contentName: string, message: string): void {
    if (result.errors && result.errors.length > 0) {
      ToasterService.instance.pop({
        type: ToastType.Error,
        text: Messages.dataQuality_setError({CONTENT_NAME: contentName})
      });
    } else {
      ToasterService.instance.pop({
        type: ToastType.Info,
        text: message
      });
    }
  }

  export async function addDataQualityWarning(args: IAddDataQualityIndicatorParams): Promise<void> {
    return WebHttpClientWithErrorToastInstance
      .sendRequestAndDelay(new AddDataQualityIndicatorRequest(args))
      .then(r => {
        return showToastForResult(r, args.contentName, Messages.dataQuality_addSuccess({CONTENT_NAME: args.contentName}));
      });
  }

  export async function updateDataQualityWarning(args: IUpdateDataQualityIndicatorParams): Promise<void> {
    return WebHttpClientWithErrorToastInstance
      .sendRequestAndDelay(new UpdateDataQualityIndicatorRequest(args))
      .then(r => {
        return showToastForResult(r, args.contentName, Messages.dataQuality_updateSuccess({CONTENT_NAME: args.contentName}));
      });
  }

  export async function deleteDataQualityWarning(args: IDeleteDataQualityIndicatorParams): Promise<void> {
    return WebHttpClientWithErrorToastInstance
      .sendRequestAndDelay(new DeleteDataQualityIndicatorRequest(args))
      .then(r => {
        return showToastForResult(r, args.contentName, Messages.dataQuality_updateSuccess({CONTENT_NAME: args.contentName}));
      });
  }
}
